module.exports = __webpack_public_path__ + "static/img/300_TO8_1961_og.6d4ddaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/300_TO8_1961_og.jpg
// module id = N0u+
// module chunks = 0